'use client';

import getPBracketsCDNURL from '@pickleballinc/ui/components/pickleball-app/utils/getPBracketsCDNURL';

import { SponsorData } from '@/types/tournaments.types';
import { PBRACKETS_UPLOADS_ROOT } from '@/utils/helpers/constants';

interface SponsorsSectionProps {
	images?: [];
	sponsors: SponsorData[];
}

export const SponsorsSection = (props: SponsorsSectionProps) => {
	const { sponsors } = props;

	const getSponsorLogoURL = (sponsor: SponsorData) => {
		const url = `${PBRACKETS_UPLOADS_ROOT}/${
			sponsor.Logo?.toLowerCase().startsWith('clubs/') ? sponsor.Logo : `events/${sponsor.ModuleID}/${sponsor.Logo}`
		}`;

		return getPBracketsCDNURL(url, 250, 250);
	};

	return (
		<div className="flex flex-col gap-4 rounded-lg bg-white">
			{sponsors[0]?.SponsorLevelTitle.toLowerCase() !== 'no level' && (
				<div className="rounded-t-lg bg-[#D5D9EB] p-2 text-lg font-bold text-blue-900">{sponsors[0]?.SponsorLevelTitle}</div>
			)}
			<div className="grid grid-cols-2 gap-4 p-4 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
				{sponsors[0]?.SponsorLevelTitle === 'Title Sponsor' ? (
					<>
						{sponsors[0]?.URL ? (
							<a
								className="col-span-2 xl:col-span-3"
								href={sponsors[0].URL?.includes('http') ? sponsors[0].URL : `https://${sponsors[0].URL}`}
							>
								<img
									src={getSponsorLogoURL(sponsors[0])}
									alt={`${sponsors[0].Title} logo`}
									className="h-24 w-full rounded-lg border bg-white object-contain p-2"
								/>
							</a>
						) : (
							<img
								src={getSponsorLogoURL(sponsors[0])}
								alt={`${sponsors[0].Title} logo`}
								className="col-span-2 h-24 w-full rounded-lg border bg-white object-contain p-2 xl:col-span-3"
							/>
						)}
					</>
				) : (
					<>
						{sponsors.map((sponsor, i) => (
							<div key={i}>
								{sponsor.URL ? (
									<a
										href={sponsor.URL.includes('http') ? sponsor.URL : `https://${sponsor.URL}`}
										target="_blank"
										rel="nofollow"
										aria-label={`Link to ${sponsor.Title} page (opens in a new tab)`}
									>
										<img
											src={getSponsorLogoURL(sponsor)}
											alt={`${sponsor.Title} logo`}
											className="h-24 w-full rounded-lg border bg-white object-contain p-2"
										/>
									</a>
								) : (
									<img
										src={getSponsorLogoURL(sponsor)}
										alt={`${sponsor.Title} logo`}
										className="h-24 w-full rounded-lg border bg-white object-contain p-2"
									/>
								)}
							</div>
						))}
					</>
				)}
			</div>
		</div>
	);
};
